<template>
  <div id="app">
    <header-view ></header-view>
    <div style="min-height: 100vh;margin-top: -1px;">
      <!-- <img class="top-img header-img pc-container" src="./assets/images/pc/common/header.jpg" > -->
      <img class="top-img header-menu__bg pc-container" src="./assets/images/pc/common/menu_bar_bg.jpg" >
      <!-- <img class="top-img header-img mobile-container" src="./assets/images/mobile/common/header.jpg" > -->
      <img class="top-img header-menu__bg mobile-container" src="./assets/images/mobile/common/menu.jpg" >
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>
import FooterView from './components/pc/FooterView.vue'
import HeaderView from './components/pc/HeaderView.vue'
import Utils from './utils/index'

export default {
  name: 'App',
  components: {
    HeaderView,
    FooterView
  },
  data() {
    return {
      isPc: Utils.isPc()
    }
  },
  mounted() {
    this.$store.dispatch('getLeaderboard')
    this.$store.dispatch('getDigitaList')
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  position: relative;
}

html, body{
  /* width: 1200px; */
  width: 100%;
  min-height: 100%;
  background: #fff;
}

img{
  display: block;
  max-width: 100%;
}

#app{
  min-width: 100vw;
  min-height: 100vh;
}

.page{
  margin-top: -2px;
}

.button{
  cursor: pointer;
  position: absolute;
  left: 0px;
  top: 0px;
}

.pc-container{
  display: block;
}
.mobile-container{
  display: none;
}

.top-img{
  width: 100vw;
  opacity: 0;
}

@media screen and ( max-width: 720px ) {
  .pc-container{
    display: none;
  }
  .mobile-container{
    display: block;
  }
  
  #app{
    min-width: 100%;
  }
}

</style>
